import { getIsVisaSRCi } from 'communicator/store/selectors';
import { CardListResponse } from 'types/api/card-list';
import { SetIntentResponse } from 'types/api/intent';
import { MaskedCardSdkPayload } from 'types/visa-sdk/get-src-profile';
import { getCardError } from './card-error';

export function getMaskedCardsFromPostIntent(response?: SetIntentResponse): MaskedCardSdkPayload[] {
  if (!response?.paymentInstrument) {
    return [];
  }

  return response.paymentInstrument.map(pi => {
    const cardError = getCardError(pi, response.merchantConfig);

    const creationTimestamp = pi.creationTimestamp;
    const lastUsedTimeStamp = pi.lastUsedTimeStamp;

    const cardInfo: MaskedCardSdkPayload = {
      cardError,
      dateOfCardCreated: creationTimestamp ? new Date(creationTimestamp).toISOString() : null,
      dateOfCardLastUsed: lastUsedTimeStamp ? new Date(lastUsedTimeStamp).toISOString() : null,
      dcf: {
        type: pi.dcfs?.dcfInfo?.[0]?.walletType ?? null
      },
      digitalCardData: {
        artHeight: pi.cardArts.cardArt[0]?.height ?? null,
        artUri: pi.cardArts.cardArt[0]?.baseImageFileName ?? null,
        artWidth: pi.cardArts.cardArt[0]?.width ?? null,
        status: pi.expired ? 'EXPIRED' : 'ACTIVE'
      },
      eligible: pi.accepted || null,
      isInstallmentEligible: Boolean(pi.isInstallmentEligible ?? false),
      maskedBillingAddress: {
        addressId: pi.billingAddressId ?? '',
        city: pi.billingAddress.city,
        countryCode: pi.billingAddress.countryCode,
        line1: pi.billingAddress.line1,
        line2: pi.billingAddress.line2,
        line3: pi.billingAddress.line3,
        state: pi.billingAddress.stateProvinceCode,
        zip: pi.billingAddress.postalCode
      },
      panBin: pi.binSixDigits || null,
      panExpirationMonth: pi.expirationDate.month,
      panExpirationYear: pi.expirationDate.year,
      panLastFour: pi.lastFourDigits,
      paymentAccountReference: pi.paymentAccountReference || null,
      srcDigitalCardId: pi.digitalCardId || pi.id,
      tokenBinRange: null,
      tokenId: pi.tokenId || null
    };

    if (getIsVisaSRCi()) {
      // TODO: getCardType
      cardInfo.cardType = '';
      cardInfo.networkId = pi.paymentType.cardBrand;
    }

    return cardInfo;
  });
}

export function getMaskedCardsFromCardList(
  profile: CardListResponse['profiles'][number]
): MaskedCardSdkPayload[] {
  // normalize EMVCo maskedCards EMVCo+Visa
  return profile.maskedCards.map(maskedCard => {
    // START GENAI@GHCOPILOT
    /* eslint-disable @typescript-eslint/no-unnecessary-condition */
    let maskedBillingAddress = maskedCard?.maskedBillingAddress;

    // START GENAI@GHCOPILOT
    if (maskedBillingAddress && typeof maskedBillingAddress === 'object') {
      // END GENAI@GHCOPILOT
      // cannot directly delete nonconfigurable properties, destructuring to omit
      const { isEditable, ...destructuredMaskedBillingAddress } = maskedCard?.maskedBillingAddress;
      maskedBillingAddress = destructuredMaskedBillingAddress;
    }
    // END GENAI@GHCOPILOT

    return {
      authenticationStep: maskedCard.authenticationStep ?? null,
      cardError: maskedCard.cardError ?? null,
      dateOfCardCreated: maskedCard.dateOfCardCreated
        ? new Date(parseInt(maskedCard.dateOfCardCreated, 10)).toISOString()
        : null,
      dateOfCardLastUsed: maskedCard.dateOfCardLastUsed
        ? new Date(parseInt(maskedCard.dateOfCardLastUsed, 10)).toISOString()
        : null,
      dcf: maskedCard.dcf,
      digitalCardData: maskedCard.digitalCardData,
      eligible: !maskedCard.cardError,
      isBiometricsEligible: maskedCard.isBiometricsEligible,
      isInstallmentEligible: false,
      maskedBillingAddress,
      panBin: maskedCard.panBin,
      panExpirationMonth: maskedCard.panExpirationMonth,
      panExpirationYear: maskedCard.panExpirationYear,
      panLastFour: maskedCard.panLastFour,
      paymentAccountReference: maskedCard.paymentAccountReference,
      // START GENAI@GHCOPILOT
      paymentCardDescriptor: maskedCard.paymentCardDescriptor ?? null,
      // END GENAI@GHCOPILOT
      paymentCardType: maskedCard.paymentCardType,
      srcDigitalCardId: maskedCard.srcDigitalCardId,
      supportedPaymentCardTypes: maskedCard.supportedPaymentCardTypes,
      tokenBinRange: maskedCard.tokenBinRange ?? null,
      tokenId: maskedCard.tokenId
    };
  });
}
